import { useLanguage } from '../utils/LanguageContext';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { createAccountWithEmailAndPasswordSchema } from '../shared/validations/userValidations';
import translations from './ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';
import { Alert, Button } from 'antd';
import { useActivationCodeData } from './common/activationCodeHook.js';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './SignupForm.css';

const SignupForm = ({ onFinish, isPayrollAdmin }) => {
  const { activationCode } = useParams();
  const { createUserWithEmailAndPassword, createAccountWithGoogle } = useAuth();
  const { lang, setCurrentLanguage } = useLanguage(translations);

  const { employerName, email, languagePreference, expired, invalid } = useActivationCodeData(activationCode);

  useEffect(() => {
    if (languagePreference) {
      setCurrentLanguage(languagePreference);
    }
  }, [languagePreference, setCurrentLanguage]);

  if (invalid) {
    return <Alert description={lang('activationCodeIsInvalid')} />;
  }
  if (expired) {
    return <Alert description={lang('activationCodeIsExpired')} />;
  }

  const handleSubmit = async ({ email, password }) =>
    await createUserWithEmailAndPassword({ email, password, isPayrollAdmin, activationCode });

  return activationCode && !employerName ? null : (
    <div className="page-container">
      <h1>{lang('createAccountTitle')}</h1>
      <Button onClick={() => createAccountWithGoogle({ isPayrollAdmin })}>{lang('createAccountWithGoogle')}</Button>
      <ValidatedForm
        key="accountInfo"
        schema={createAccountWithEmailAndPasswordSchema}
        initialValues={{ email }}
        handleSubmit={handleSubmit}
        onFinish={onFinish}
      >
        {employerName && (
          <Alert
            type="info"
            description={
              <>
                <b>{employerName}</b>
                <br />
                {lang('employerRequestsYourSignup')}
              </>
            }
          />
        )}
        <div className="form-input-group">
          <FormInput name="email" type="email" />
          <FormInput name="password" type="password" />
        </div>
        <FormSubmit classname="createAccountbutton">{lang('createAccount')}</FormSubmit>
      </ValidatedForm>
    </div>
  );
};

export default SignupForm;
